import BaseModel from '../base/BaseModel.model';
import TipoEvaluacion from '../evaluacion/tipoEvaluacion.model';
import AnnoucementRequiredEvaluationType from './annoucementRequiredEvaluationType.Model';
import ProporsalUsersEvaluators from '../porposal/proporsalUsersEvaluators.Model';

export default class AnnoucementEvaluationType extends BaseModel {
    
    public annoucementId: number;
    public evaluationTypeId: number;
    public minimumNumberOfEvaluators: number;
    public annoucementRequiredEvaluationTypes: Array<AnnoucementRequiredEvaluationType> = [];
    public evaluationType: TipoEvaluacion = new TipoEvaluacion();
    public isMainEvaluation: boolean = false;
    // ui helpers
    public evaluatorUI: any;
    public maximumEvaluationDateUI: any;
    public proporsalUsersEvaluators: Array<ProporsalUsersEvaluators> = [];
    constructor(){
        super();
        this.init();
    }

    init(){
        this.minimumNumberOfEvaluators = 1;
        this.evaluationTypeId = 0;
        this.annoucementId = 0;
        this.evaluatorUI = null;
        this.maximumEvaluationDateUI = null;
    }
}